import { PercentageOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import DataTable from "../../../Components/DataTable/DataTable";
import { connect } from "react-redux";
import * as actions from "../../../store/actions/action";
import { dataFetchError } from "../../../Util/Messages";
import api from "../../../api/api";
import { Input, message, Select, Tag } from "antd";
import { Chip } from "@mui/material";

const Product = ({ LoadingSetter, ClearLoading, loading }) => {
  const [data, setData] = useState([]);
  const [flagsCategories, setFlagsCategories] = useState([]);
  const columns = [
    {
      title: "نام محصول",
      dataIndex: "title",
      searchable: true,
      renderFormItem: (_, { isEditable, record }) => <Input />,
    },
    {
      title: "کد محصول",
      dataIndex: "code",
      align: "center",
      searchable: true,
      renderFormItem: (_, { isEditable, record }) => <Input />,
    },
    {
      title: "وضعیت",
      dataIndex: "active",
      align: "center",
      filters: [
        { text: "فعال", value: true },
        { text: "غیر فعال", value: false },
      ],
      onFilter: (val, record) => record.active === val,
      renderFormItem: (_, { isEditable, record }) => (
        <Select
          style={{ width: "100%" }}
          placeholder="انتخاب کنید"
          options={[
            { label: "فعال", value: true },
            { label: "غیر فعال", value: false },
          ]}
        />
      ),
      render: (isActive) =>
        isActive ? (
          <Tag color="success">فعال</Tag>
        ) : (
          <Tag color="warning">غیر فعال</Tag>
        ),
    },
    {
      title: "عنوان مخفی",
      dataIndex: "privateTitle",
      searchable: true,
      renderFormItem: (_, { isEditable, record }) => <Input />,
    },

    {
      title: "مبلغ",
      dataIndex: "price",
      render: (value) => {
        if (!value) return "";
        return parseInt(value)?.toLocaleString();
      },
      renderFormItem: (_, { isEditable, record }) => <Input type="number" />,
    },

    {
      title: "مقدار تخفیف",
      dataIndex: "discount",
      render: (value) => {
        if (!value) return "";
        return parseInt(value)?.toLocaleString();
      },
      renderFormItem: (_, { isEditable, record }) => <Input type="number" />,
    },

    {
      title: "مبلغ تمدید",
      dataIndex: "renewal_price",
      render: (value) => {
        if (value === null || value === undefined || value === "") return "";
        const parsed = parseInt(value);
        if (isNaN(parsed)) return "";
        return parsed.toLocaleString();
      },
      renderFormItem: (_, { isEditable, record }) => <Input type="number" />,
    },

    {
      title: "مبلغ تمدید (۰ الی ۱ ماه)",
      dataIndex: "renewal_price_1m",
      render: (value) => {
        if (value === null || value === undefined || value === "") return "";
        const parsed = parseInt(value);
        if (isNaN(parsed)) return "";
        return parsed.toLocaleString();
      },
      renderFormItem: (_, { isEditable, record }) => <Input type="number" />,
    },

    {
      title: "مبلغ تمدید (۱ الی ۳ ماه)",
      dataIndex: "renewal_price_3m",
      render: (value) => {
        if (value === null || value === undefined || value === "") return "";
        const parsed = parseInt(value);
        if (isNaN(parsed)) return "";
        return parsed.toLocaleString();
      },
      renderFormItem: (_, { isEditable, record }) => <Input type="number" />,
    },

    {
      title: "مبلغ تمدید (۳ الی ۶ ماه)",
      dataIndex: "renewal_price_6m",
      render: (value) => {
        if (value === null || value === undefined || value === "") return "";
        const parsed = parseInt(value);
        if (isNaN(parsed)) return "";
        return parsed.toLocaleString();
      },
      renderFormItem: (_, { isEditable, record }) => <Input type="number" />,
    },

    {
      title: "فرم ایپل",
      dataIndex: "epollFormId",
      searchable: true,

      renderFormItem: (_, { isEditable, record }) => <Input />,
    },
    {
      title: "لینک تصویر",
      dataIndex: "imageLink",
      align: "center",
      searchable: true,
      renderFormItem: (_, { isEditable, record }) => <Input />,
    },
    {
      title: "توضیحات",
      dataIndex: "description",
      align: "center",
      searchable: true,
      renderFormItem: (_, { isEditable, record }) => <Input.TextArea />,
      // render: (value) => (value.trim() ? value.slice(0, 50) + "... " : "-"),
      render: (isActive) =>
        isActive ? (
          <Tag color="success">فعال</Tag>
        ) : (
          <Tag color="warning">غیر فعال</Tag>
        ),
    },
    {
      title: "لینک فرم",
      dataIndex: "formLink",
      align: "center",
      searchable: true,
      renderFormItem: (_, { isEditable, record }) => <Input />,
    },
    {
      title: "پرچم های مربوط",
      dataIndex: "relatedFlagsCategories",
      align: "center",
      renderFormItem: (_, { isEditable, record }) => {
        console.warn({ record });

        return (
          <Select
            mode="tags"
            allowClear
            values={record.relatedFlagsCategories}
            style={{ width: "100%" }}
            placeholder="دسته بندی کارت"
          >
            {(flagsCategories ?? [])?.map((category) => (
              <Select.Option key={category} value={category}>
                {category}
              </Select.Option>
            ))}
          </Select>
        );
      },
      render: (desc, record) => {
        return record.relatedFlagsCategories?.map((e, i) => (
          <Chip key={i} label={e} />
        ));
      },
    },
    // {
    //   title: "فرم‌ها",
    //   align: "center",
    //   dataIndex: "forms",
    //   renderFormItem: (_, { isEditable, record }) => {
    //     return "-";
    //     if (isEditable) {
    //       return <Input.TextArea />;
    //     }
    //   },
    //   render: (value, record) => {
    //     return "-";
    //     return (value ?? []).map((e) => <Tag key={e.id}>{e.title}</Tag>);
    //   },
    // },
  ];

  const getFlagCategories = () => {
    api
      .get("/flags/category")
      .then((res) =>
        setFlagsCategories(
          res?.data?.filter((e) => e && e?.trim() !== "") ?? []
        )
      )
      .catch(() => message.error("خطا در دریافت دسته بندی ها"));
  };

  const loadData = () => {
    LoadingSetter();
    api
      .get("/product/admin")
      .then((res) => setData(res.data))
      .catch((err) => {
        console.log(err);
        dataFetchError();
      })
      .finally(() => ClearLoading());
  };

  const updateRecord = async (code, data) => {
    console.log({ code, data });
    return await api
      .put("/product/" + code, {
        title: data.title,
        code: data.code,
        privateTitle: data.privateTitle ?? "",
        discount: data.discount?.toString().trim() ? +data.discount : null,
        price: data.price?.toString().trim() ? +data.price : null,
        renewal_price: data.renewal_price?.toString().trim() ? +data.renewal_price : null,
        renewal_price_1m: data.renewal_price_1m?.toString().trim() ? +data.renewal_price_1m : null,
        renewal_price_3m: data.renewal_price_3m?.toString().trim() ? +data.renewal_price_3m : null,
        renewal_price_6m: data.renewal_price_6m?.toString().trim() ? +data.renewal_price_6m : null,
        epollFormId: data.epollFormId?.toString().trim() ? +data.epollFormId : null,
        description: data.description ?? "",
        formLink: data.formLink,
        imageLink: data.imageLink ?? "",
        active: data.active,
        forms: [],
        relatedFlagsCategories: data.relatedFlagsCategories ?? [],
      })
      .then(() => message.success("با موفقیت آپدبت شد"))
      .catch(() => message.error("خطا در آپدیت"))
      .finally(() => ClearLoading());
  };

  const saveRecord = async (data) => {
    console.log({ data });
    return await api
      .post("/product", {
        title: data.title,
        code: data.code,
        privateTitle: data.privateTitle ?? "",
        discount: data.discount?.toString().trim() ? +data.discount : null,
        price: data.price?.toString().trim() ? +data.price : null,
        renewal_price: data.renewal_price?.toString().trim() ? +data.renewal_price : null,
        renewal_price_1m: data.renewal_price_1m?.toString().trim() ? +data.renewal_price_1m : null,
        renewal_price_3m: data.renewal_price_3m?.toString().trim() ? +data.renewal_price_3m : null,
        renewal_price_6m: data.renewal_price_6m?.toString().trim() ? +data.renewal_price_6m : null,
        epollFormId: data.epollFormId?.toString().trim() ? +data.epollFormId : null,
        description: data.description ?? "",
        formLink: data.formLink,
        imageLink: data.imageLink ?? "",
        active: data.active,
        forms: [],
        relatedFlagsCategories: data.relatedFlagsCategories ?? [],
      })
      .then(() => message.success("با موفقیت ثبت شد"))
      .catch(() => message.error("خطا در ثبت"))
      .finally(() => ClearLoading());
  };

  const onSaveHandler = async (row, rowData) => {
    LoadingSetter();
    let oldData = data.find((e) => e.id === row.id);
    return oldData
      ? updateRecord(row.code, rowData).then(() => {})
      : saveRecord(rowData).then(() => {});
  };

  useEffect(() => {
    loadData();
    getFlagCategories();
  }, []);

  return (
    <>
      <DataTable
        dataSource={data}
        onSave={onSaveHandler}
        setDataSource={setData}
        columns={columns}
        reload={loadData}
        editable
        keepPageOnSave
        hideComment
        hideErrorReport
        permissionsPrefix="flags"
        header={{
          title: "محصولات",
          avatar: { icon: <PercentageOutlined />, size: "large" },
        }}
      />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Product);
